import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

export type GAHMatDialogData = {
  title: string;
  message: string;
  cancelText: string;
  okayText: string;
  okayButtonColored?: boolean;
};

@Component({
    selector: 'app-gah-mat-dialog',
    templateUrl: './gah-mat-dialog.component.html',
    styleUrls: ['./gah-mat-dialog.component.scss'],
    standalone: false
})
export class GahMatDialogComponent {
  constructor(@Inject(MAT_DIALOG_DATA) public data: GAHMatDialogData) {}
}
